import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { UserContextProvider } from './contexts/UserContext';
import { PageContextProvider } from './contexts/PageContext';
import { theme } from "./theme";
import "./style.css";

import App from './App';

const container = document.getElementById('bimm-app');
const root = createRoot(container);
root.render(
  <UserContextProvider>
    <PageContextProvider>
      <BrowserRouter>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <App />
          </ThemeProvider>
      </BrowserRouter>
    </PageContextProvider>
  </UserContextProvider>
);